import {
    useFormStateSelector,
    addFormSection,
    setFormSections,
    setCurrentSectionIndex,
    resetFormState,
    setFormSectionError,
    FormSectionErrorType,
    setIsFormSubmitDisabled,
} from './../store/features/form';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useFormState = () => {
    const formState = useSelector(useFormStateSelector);
    const dispatch = useDispatch();

    const handleSetIsFormSubmitDisabled = useCallback(
        (value: boolean) => dispatch(setIsFormSubmitDisabled(value)),
        [dispatch]
    );

    const handleAddFormSection = useCallback(
        (newFormSection: string) => {
            dispatch(addFormSection(newFormSection));
        },
        [dispatch]
    );

    const handleSetFormSections = useCallback(
        (newFormSections: string[]) => {
            dispatch(setFormSections(newFormSections));
        },
        [dispatch]
    );

    const handleSetCurrentSectionIndex = useCallback(
        (newFormSectionIndex: number) =>
            dispatch(setCurrentSectionIndex(newFormSectionIndex)),
        [dispatch]
    );
    const handleSetFormSectionError = useCallback(
        (newFormSectionError: FormSectionErrorType) =>
            dispatch(setFormSectionError(newFormSectionError)),
        [dispatch]
    );

    const handleResetFormState = useCallback(
        () => dispatch(resetFormState()),
        [dispatch]
    );

    return useMemo(() => {
        return {
            ...formState,
            addFormSection: handleAddFormSection,
            setFormSections: handleSetFormSections,
            setCurrentSectionIndex: handleSetCurrentSectionIndex,
            resetFormState: handleResetFormState,
            setFormSectionError: handleSetFormSectionError,
            setIsFormSubmitDisabled: handleSetIsFormSubmitDisabled,
        };
    }, [
        formState,
        handleAddFormSection,
        handleResetFormState,
        handleSetCurrentSectionIndex,
        handleSetFormSections,
        handleSetFormSectionError,
        handleSetIsFormSubmitDisabled,
    ]);
};
